/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import useChangedStateOnOutsideClick from "src/utils/useChangedStateOnOutsideClick";
import useBooleanState from "../../../../../hooks/utils/useBooleanState";
import { isNativeApp } from "../../../../../utils/nativeUtils";
import Loader from "../../../../atoms/Loader";
import CardList from "./CardList";
import NativeNotificationIcon from "./NativeNotificationIcon";
import {
  bellLoaderCss,
  NotificationsCollapseContainer,
  NotificationsIconContainer,
  NotificationsListItem,
  StyledNotificationIndicator as Indicator,
  StyledNotificationsIcon,
} from "./styles";

type Props = {
  notificationCount: number;
  isLoading: boolean;
};

const Notifications: FC<Props> = ({ notificationCount, isLoading }) => {
  const { ref, isOpen, setIsOpen } =
    useChangedStateOnOutsideClick<HTMLLIElement>();

  if (isNativeApp()) return <NativeNotificationIcon isOpen={isOpen} />;

  const toggleCollapse = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <NotificationsListItem ref={ref}>
      <NotificationsIconContainer
        id="tour-notifications"
        onClick={toggleCollapse}
        type="button"
      >
        <StyledNotificationsIcon isActive={isOpen} />
        {!isLoading && (
          <Indicator notificationCount={notificationCount}>
            {notificationCount}
          </Indicator>
        )}
        {isLoading && <Loader css={bellLoaderCss} size={22} />}
      </NotificationsIconContainer>
      <NotificationsCollapseContainer visible={isOpen}>
        <CardList onCardClickSideEffect={toggleCollapse} />
      </NotificationsCollapseContainer>
    </NotificationsListItem>
  );
};

export default Notifications;
export type ControlledProps = Props;
